import React from 'react'
import { SVGIconProps } from '../types'
const SvgSortDescending = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 20"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#0C1720"
        d="M5.963.43a1.467 1.467 0 0 1 2.074 0l5.533 5.533a1.467 1.467 0 1 1-2.075 2.074L7 3.542 2.505 8.037A1.467 1.467 0 0 1 .43 5.963z"
      />
      <path
        fill="#748999"
        d="M8.037 18.694a1.467 1.467 0 0 1-2.074 0L.43 13.161a1.467 1.467 0 1 1 2.075-2.074L7 15.582l4.495-4.495a1.467 1.467 0 0 1 2.075 2.074z"
      />
    </g>
  </svg>
)
export default SvgSortDescending
